// @flow
import { resolve } from 'redux-optimist-promise';

import { FETCH_PROPOSALS_BY_ID, FETCH_PROPOSALS } from 'Store/booking/proposals/constants';
import { UPDATE_VALIDATION_SCHEMA } from 'Store/validation-schema/constants';

export type State = {
  'profile.address': Array<ValidationSchema>,
};
const initialState = {
  'profile.address': [],
};

const reducer = (state: State = initialState, action: Action<*>): State => {
  switch (action.type) {
    case resolve(FETCH_PROPOSALS):
    case resolve(FETCH_PROPOSALS_BY_ID):
    case UPDATE_VALIDATION_SCHEMA: {
      const { validationSchema } = action.payload;
      if (!validationSchema) return state;

      const addressEntry = validationSchema.find(entry => entry.name === 'address');

      return addressEntry
        ? {
            'profile.address': addressEntry.fields.map(validation => ({
              ...validation,
              validators: validation.validators.map(
                validator =>
                  validator.name === 'pattern'
                    ? {
                        name: 'pattern',
                        value: new RegExp(validator.value),
                      }
                    : validator,
              ),
            })),
          }
        : state;
    }

    default:
      return state;
  }
};
export default reducer;
